import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-[repeat(9,_minmax(0,_1fr))_35px] gap-3 font-bold py-2" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = { class: "grid grid-cols-[repeat(9,_minmax(0,_1fr))_35px] gap-3 font-bold mb-3" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = { class: "py-2 flex" }
const _hoisted_9 = { class: "flex flex-col mr-3 grow" }
const _hoisted_10 = { class: "flex flex-col mr-3 w-1/4" }
const _hoisted_11 = { class: "flex justify-end pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_ctx.sections) + " ", 1),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "col-span-6" }, "Fee", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "col-span-2" }, "%", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "" }, "Predefinita", -1)),
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.addFee,
        class: "col flex justify-center items-center h-8 w-8"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
        ])),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fee_data, (f, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "grid grid-cols-[repeat(9,_minmax(0,_1fr))_35px] gap-3 mb-3 items-cente",
        key: i
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Field, {
            modelValue: f.descrizione,
            "onUpdate:modelValue": ($event: any) => ((f.descrizione) = $event),
            "label-visible": false,
            placeholder: "Descrizione"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          min: "0",
          step: ".01",
          "onUpdate:modelValue": ($event: any) => ((f.valore) = $event),
          placeholder: "Valore",
          class: "col-span-2 p-2 bg-next-gray-md-dark hover:bg-white w-full"
        }, null, 8, _hoisted_3), [
          [_vModelText, f.valore]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Radio, {
            value: i,
            name: "default",
            modelValue: _ctx.default_fee,
            "onUpdate:modelValue": _ctx.updateVal,
            checkClass: "w-3 h-3"
          }, null, 8, ["value", "modelValue", "onUpdate:modelValue"])
        ]),
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          onClick: ($event: any) => (_ctx.removeFee(i)),
          class: "col flex justify-center items-center h-8 w-8"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "icon-x" }, null, -1)
          ])),
          _: 2
        }, 1032, ["onClick"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_5, [
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "col-span-6" }, "Rebate", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "col-span-3" }, "%", -1)),
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.addRebate,
        class: "col flex justify-center items-center h-8 w-8"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
        ])),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rebate_data, (f, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "grid grid-cols-[repeat(9,_minmax(0,_1fr))_35px] gap-3 mb-3 items-center",
        key: i
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Field, {
            modelValue: f.descrizione,
            "onUpdate:modelValue": ($event: any) => ((f.descrizione) = $event),
            "label-visible": false,
            placeholder: "Descrizione"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          min: "0",
          step: ".01",
          "onUpdate:modelValue": ($event: any) => ((f.valore) = $event),
          placeholder: "Valore",
          class: "col-span-3 p-2 bg-next-gray-md-dark hover:bg-white w-full"
        }, null, 8, _hoisted_7), [
          [_vModelText, f.valore]
        ]),
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          onClick: ($event: any) => (_ctx.removeRebate(i)),
          class: "col flex justify-center items-center h-8 w-8"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "icon-x" }, null, -1)
          ])),
          _: 2
        }, 1032, ["onClick"])
      ]))
    }), 128)),
    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "block border-b" }, null, -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Field, {
          modelValue: _ctx.default_markup_data,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.default_markup_data) = $event)),
          field_name: "Mark-up di default",
          placeholder: "Mark-up percentuale",
          type: "number"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Field, {
          field_name: "Applica alla sezione",
          required: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VueMultiselect, {
              options: _ctx.sections,
              modelValue: _ctx.section_to_apply,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.section_to_apply) = $event)),
              "track-by": "id",
              label: "titolo",
              placeholder: "sezione",
              deselectLabel: "Deseleziona",
              selectedLabel: "Selezionato",
              selectLabel: "Seleziona",
              class: "next-vue-multiselect-single"
            }, null, 8, ["options", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.applicaATutti,
        class: "col-start-3 py-2 px-4 self-end"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.applicaLabel), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        onClick: _ctx.chiudi,
        class: "col-start-3 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode(" Chiudi ")
        ])),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.save,
        class: "ml-4 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode(" Salva ")
        ])),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}